'use strict';

// import * as d3 from 'd3';
import { tip as d3Tip } from 'd3-v6-tip';

class Tooltip {
  constructor () {
    this.tip = d3Tip().attr('class', 'd3-tip').html((EVENT, d) => d);
  }

  show (event, data, template) {
    let content = !template ? '<strong>{{title}}</strong><br>{{value}}' : template;
    for (const [key, value] of Object.entries(data)) {
      const token = '{{' + key + '}}';
      content = content.replace(token, value);
    }
    this.tip.show(event, content);
  }

  hide () {
    this.tip.hide();
  }
}

const createTooltip = () => {
  // const tooltip = d3Tip().html((EVENT, d) => d);
  const tooltip = new Tooltip();
  return tooltip;
};

// export const showTooltip = (tooltip, event, data, template) => {
//   const _template = template ?? `<strong>${data.title}</strong><br>${data.value}`;
//   tooltip.show(event, _template);
// };

// export const hideTooltip = (tooltip) => {
//   tooltip.hide();
// };
export const getTooltipContent = function (templateText, data) {
  // const re = /(?<=\[\[).+?(?=\]\])/g; // not supported by Safari
  const re = /(\[\[).+?(?=\]\])/g;
  let result = templateText;
  const matches = templateText.match(re);
  for (const match_ of matches) {
    const match = match_.split('[[')[1];
    const vals = match.split('#');
    if (['internal'].includes(vals[0])) {
      result = result.replace(`[[${match}]]`, data[vals[1]]);
      continue;
    }
    if (['global'].includes(vals[0])) {
      result = result.replace(`[[${match}]]`, this[vals[1]]);
    }
    result = result.replace(`[[${match}]]`, data[vals[0]]);
  }
  return result;
};
export const getTooltipTemplate = (templateText, internalVal, globalVal) => {
  // const re = /(?<=\[\[).+?(?=\]\])/g; // not supported by Safari
  const re = /(\[\[).+?(?=\]\])/g;
  let result = templateText;
  const matches = templateText.match(re);
  for (const match_ of matches) {
    const match = match_.split('[[')[1];
    const vals = match.split('#');
    let iterateVal = '';
    if (vals[0] === 'internal') {
      iterateVal = internalVal;
    } else if (vals[0] === 'global') {
      iterateVal = globalVal;
    }
    if (iterateVal) {
      result = result.replace(`[[${match}]]`, `$\{${iterateVal}.${vals[1]}}`);
    } else {
      result = result.replace(`[[${match}]]`, `$\{${vals[0]}}`);
    }
  }
  return result;
};

export default createTooltip;
